module.exports = __webpack_public_path__ + "img/RelpenPick.e1ea4e48.png";